'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'
import { ComingUpItemCardContent } from '../ComingUpItemCardContent/ComingUpItemCardContent'

export const ComingUpItem = ({ item }) => {
  return (
    <MUIStack
      data-testid="ComingUpItem"
      sx={{
        backgroundColor: 'background.paper',
        borderRadius: 1,
        ml: 4,
        mr: 4,
        mb: '7px',
        interpolateSize: 'allow-keywords',
        overflow: 'hidden',
        transition: 'all 400ms',
        width: 'calc(100% - 32px)',
        cursor: item?.isUserRestricted ? 'not-allowed' : 'auto'
      }}
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
    >
      <ComingUpItemCardContent item={item} />
    </MUIStack>
  )
}

ComingUpItem.propTypes = {
  item: PropTypes.object,
  isMatterSpecific: PropTypes.bool
}
